import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { User } from '../../auth/models/user.model';
import { SENTRY, SentryErrors } from '../interfaces/sentry.interface';
import { AuthService } from '../../auth/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorsService {

  public static getError(err) {
    if (err instanceof Error) {
      return err;
    }
    if (typeof err === 'string' || err instanceof String) {
      return new Error(err.toString());
    }
    const newErr = new Error(err?.message || 'unexpected');
    for (const [key, value] of Object.entries(err)) {
      newErr[key] = value;
    }
    return newErr;
  }

  constructor(
    @Inject(SENTRY) private sentry: SentryErrors,
    private auth: AuthService,
  ) {
  }

  public track(e, tags = []) {
    if (e instanceof HttpErrorResponse) {
      this.setContext('HTTP_ERROR', e);
    }
    e = ErrorsService.getError(e);
    if (tags && tags.length > 0) {
      this.setContext('errorTags', tags);
    }
    this.setUser(this.auth.currentUser);
    this.sentry.captureException(e?.originalError || e);
  }

  public trackAndThrow(e) {
    e = ErrorsService.getError(e);
    this.setUser(this.auth.currentUser);
    this.sentry.captureException(e?.originalError || e);
    throw e;
  }

  public setUser(user: User) {
    try {
      if (user) {
        this.sentry.setUser({
          email: user?.email,
          username: user?.login,
        });
      } else {
        this.sentry.configureScope(scope => scope.setUser(null));
      }
    } catch (e) {
      this.track(e);
    }
  }

  public setContext(key: string, data: any) {
    this.sentry.setContext(key, data);
  }


}
